module.exports = __webpack_public_path__ + "fonts/Roboto-Medium-webfont.1d2af757.ttf";